/** Default delivery form state — shared by create/edit/reset. */
export const EMPTY_DELIVERY_FORM = {
  delivery_reference: '',
  order_reference: '',
  tracking_number: '',
  delivery_date: '',
  scheduled_date: '',
  actual_date: '',
  delivery_time: '',
  delivery_type: 'standard',
  delivery_method: 'truck',
  status: 'pending',
  priority: 'medium',
  customer_id: '',
  customer_name: '',
  customer_phone: '',
  customer_email: '',
  delivery_address: '',
  delivery_city: '',
  delivery_region: '',
  delivery_postal_code: '',
  delivery_country: 'SA',
  delivery_instructions: '',
  access_code: '',
  floor_number: '',
  building_name: '',
  landmark: '',
  latitude: '',
  longitude: '',
  driver_name: '',
  driver_phone: '',
  driver_id: '',
  vehicle_number: '',
  vehicle_type: '',
  items_count: '',
  total_weight: '',
  total_volume: '',
  package_count: '',
  package_type: '',
  fragile: 'no',
  signature_required: 'yes',
  photo_required: 'no',
  id_verification: 'no',
  delivery_cost: '',
  fuel_cost: '',
  toll_cost: '',
  other_costs: '',
  total_cost: '',
  payment_method: '',
  payment_status: 'pending',
  cod_amount: '',
  collected_amount: '',
  attempt_number: '1',
  reason_for_delay: '',
  exception_notes: '',
  proof_of_delivery: '',
  customer_signature: '',
  delivery_photo: '',
  rating: '',
  feedback: '',
  notes: '',
  internal_notes: '',
  created_by: '',
  assigned_to: '',
  approved_by: '',
  completed_by: '',
  estimated_duration: '',
  actual_duration: '',
  distance_km: '',
  route_id: '',
  zone: '',
  territory: '',
  service_level: 'standard',
  temperature_controlled: 'no',
  min_temperature: '',
  max_temperature: '',
  insurance_value: '',
  insurance_provider: '',
  customs_required: 'no',
  customs_reference: '',
  tax_amount: '',
  discount_amount: '',
  tip_amount: '',
  return_required: 'no',
  return_reason: '',
  reschedule_count: '0',
  cancellation_reason: '',
  warehouse_notes: '',
  loading_notes: '',
  unloading_notes: '',
  special_handling: '',
  hazmat: 'no',
  hazmat_class: '',
  perishable: 'no',
  expiry_date: '',
  batch_number: '',
  barcode: '',
  qr_code: '',
  manifest_number: '',
  pod_number: '',
  eta: '',
  eta_accuracy: '',
  delay_minutes: '',
  sla_met: 'yes',
  sla_breach_reason: '',
  escalation_level: '0',
  compliance_checked: 'yes',
  audit_status: 'pending',
  quality_score: '',
  performance_score: '',
  customer_satisfaction: '',
  nps_score: '',
  complaint_filed: 'no',
  complaint_reference: '',
  incident_reported: 'no',
  incident_reference: '',
  damage_reported: 'no',
  damage_description: '',
  damage_value: '',
  insurance_claim: 'no',
  claim_reference: '',
  refund_issued: 'no',
  refund_amount: '',
  credit_issued: 'no',
  credit_amount: '',
};

const stringField = (val) => (val == null ? '' : String(val));

export function mapDeliveryToForm(delivery) {
  if (!delivery) return { ...EMPTY_DELIVERY_FORM };
  return {
    ...EMPTY_DELIVERY_FORM,
    delivery_reference: delivery.delivery_reference || '',
    order_reference: delivery.order_reference || '',
    tracking_number: delivery.tracking_number || '',
    delivery_date: delivery.delivery_date || '',
    scheduled_date: delivery.scheduled_date || '',
    actual_date: delivery.actual_date || '',
    delivery_time: delivery.delivery_time || '',
    delivery_type: delivery.delivery_type || 'standard',
    delivery_method: delivery.delivery_method || 'truck',
    status: delivery.status || 'pending',
    priority: delivery.priority || 'medium',
    customer_id: delivery.customer_id ? String(delivery.customer_id) : '',
    customer_name: delivery.customer_name || '',
    customer_phone: delivery.customer_phone || '',
    customer_email: delivery.customer_email || '',
    delivery_address: delivery.delivery_address || '',
    delivery_city: delivery.delivery_city || '',
    delivery_region: delivery.delivery_region || '',
    delivery_postal_code: delivery.delivery_postal_code || '',
    delivery_country: delivery.delivery_country || 'SA',
    delivery_instructions: delivery.delivery_instructions || '',
    access_code: delivery.access_code || '',
    floor_number: delivery.floor_number || '',
    building_name: delivery.building_name || '',
    landmark: delivery.landmark || '',
    latitude: stringField(delivery.latitude),
    longitude: stringField(delivery.longitude),
    driver_name: delivery.driver_name || '',
    driver_phone: delivery.driver_phone || '',
    driver_id: delivery.driver_id || '',
    vehicle_number: delivery.vehicle_number || '',
    vehicle_type: delivery.vehicle_type || '',
    items_count: stringField(delivery.items_count),
    total_weight: stringField(delivery.total_weight),
    total_volume: stringField(delivery.total_volume),
    package_count: stringField(delivery.package_count),
    package_type: delivery.package_type || '',
    fragile: delivery.fragile || 'no',
    signature_required: delivery.signature_required || 'yes',
    photo_required: delivery.photo_required || 'no',
    id_verification: delivery.id_verification || 'no',
    delivery_cost: stringField(delivery.delivery_cost),
    fuel_cost: stringField(delivery.fuel_cost),
    toll_cost: stringField(delivery.toll_cost),
    other_costs: stringField(delivery.other_costs),
    total_cost: stringField(delivery.total_cost),
    payment_method: delivery.payment_method || '',
    payment_status: delivery.payment_status || 'pending',
    cod_amount: stringField(delivery.cod_amount),
    collected_amount: stringField(delivery.collected_amount),
    attempt_number: stringField(delivery.attempt_number || '1'),
    reason_for_delay: delivery.reason_for_delay || '',
    exception_notes: delivery.exception_notes || '',
    proof_of_delivery: delivery.proof_of_delivery || '',
    customer_signature: delivery.customer_signature || '',
    delivery_photo: delivery.delivery_photo || '',
    rating: stringField(delivery.rating),
    feedback: delivery.feedback || '',
    notes: delivery.notes || '',
    internal_notes: delivery.internal_notes || '',
    created_by: delivery.created_by || '',
    assigned_to: delivery.assigned_to || '',
    approved_by: delivery.approved_by || '',
    completed_by: delivery.completed_by || '',
    estimated_duration: delivery.estimated_duration || '',
    actual_duration: delivery.actual_duration || '',
    distance_km: stringField(delivery.distance_km),
    route_id: delivery.route_id || '',
    zone: delivery.zone || '',
    territory: delivery.territory || '',
    service_level: delivery.service_level || 'standard',
    temperature_controlled: delivery.temperature_controlled || 'no',
    min_temperature: stringField(delivery.min_temperature),
    max_temperature: stringField(delivery.max_temperature),
    insurance_value: stringField(delivery.insurance_value),
    insurance_provider: delivery.insurance_provider || '',
    customs_required: delivery.customs_required || 'no',
    customs_reference: delivery.customs_reference || '',
    tax_amount: stringField(delivery.tax_amount),
    discount_amount: stringField(delivery.discount_amount),
    tip_amount: stringField(delivery.tip_amount),
    return_required: delivery.return_required || 'no',
    return_reason: delivery.return_reason || '',
    reschedule_count: stringField(delivery.reschedule_count || '0'),
    cancellation_reason: delivery.cancellation_reason || '',
    warehouse_notes: delivery.warehouse_notes || '',
    loading_notes: delivery.loading_notes || '',
    unloading_notes: delivery.unloading_notes || '',
    special_handling: delivery.special_handling || '',
    hazmat: delivery.hazmat || 'no',
    hazmat_class: delivery.hazmat_class || '',
    perishable: delivery.perishable || 'no',
    expiry_date: delivery.expiry_date || '',
    batch_number: delivery.batch_number || '',
    barcode: delivery.barcode || '',
    qr_code: delivery.qr_code || '',
    manifest_number: delivery.manifest_number || '',
    pod_number: delivery.pod_number || '',
    eta: delivery.eta || '',
    eta_accuracy: delivery.eta_accuracy || '',
    delay_minutes: stringField(delivery.delay_minutes),
    sla_met: delivery.sla_met || 'yes',
    sla_breach_reason: delivery.sla_breach_reason || '',
    escalation_level: stringField(delivery.escalation_level || '0'),
    compliance_checked: delivery.compliance_checked || 'yes',
    audit_status: delivery.audit_status || 'pending',
    quality_score: stringField(delivery.quality_score),
    performance_score: stringField(delivery.performance_score),
    customer_satisfaction: stringField(delivery.customer_satisfaction),
    nps_score: stringField(delivery.nps_score),
    complaint_filed: delivery.complaint_filed || 'no',
    complaint_reference: delivery.complaint_reference || '',
    incident_reported: delivery.incident_reported || 'no',
    incident_reference: delivery.incident_reference || '',
    damage_reported: delivery.damage_reported || 'no',
    damage_description: delivery.damage_description || '',
    damage_value: stringField(delivery.damage_value),
    insurance_claim: delivery.insurance_claim || 'no',
    claim_reference: delivery.claim_reference || '',
    refund_issued: delivery.refund_issued || 'no',
    refund_amount: stringField(delivery.refund_amount),
    credit_issued: delivery.credit_issued || 'no',
    credit_amount: stringField(delivery.credit_amount),
  };
}

export function buildDeliveryPayload(formData) {
  return {
    delivery_reference: formData.delivery_reference,
    order_reference: formData.order_reference,
    tracking_number: formData.tracking_number,
    delivery_date: formData.delivery_date,
    scheduled_date: formData.scheduled_date,
    actual_date: formData.actual_date,
    delivery_time: formData.delivery_time,
    delivery_type: formData.delivery_type,
    delivery_method: formData.delivery_method,
    status: formData.status,
    priority: formData.priority,
    customer_id: formData.customer_id || null,
    customer_name: formData.customer_name,
    customer_phone: formData.customer_phone,
    customer_email: formData.customer_email,
    delivery_address: formData.delivery_address,
    delivery_city: formData.delivery_city,
    delivery_region: formData.delivery_region,
    delivery_postal_code: formData.delivery_postal_code,
    delivery_country: formData.delivery_country,
    delivery_instructions: formData.delivery_instructions,
    access_code: formData.access_code,
    floor_number: formData.floor_number,
    building_name: formData.building_name,
    landmark: formData.landmark,
    latitude: parseFloat(formData.latitude) || 0,
    longitude: parseFloat(formData.longitude) || 0,
    driver_name: formData.driver_name,
    driver_phone: formData.driver_phone,
    driver_id: formData.driver_id,
    vehicle_number: formData.vehicle_number,
    vehicle_type: formData.vehicle_type,
    items_count: parseInt(formData.items_count, 10) || 0,
    total_weight: parseFloat(formData.total_weight) || 0,
    total_volume: parseFloat(formData.total_volume) || 0,
    package_count: parseInt(formData.package_count, 10) || 0,
    package_type: formData.package_type,
    fragile: formData.fragile,
    signature_required: formData.signature_required,
    photo_required: formData.photo_required,
    id_verification: formData.id_verification,
    delivery_cost: parseFloat(formData.delivery_cost) || 0,
    fuel_cost: parseFloat(formData.fuel_cost) || 0,
    toll_cost: parseFloat(formData.toll_cost) || 0,
    other_costs: parseFloat(formData.other_costs) || 0,
    total_cost: parseFloat(formData.total_cost) || 0,
    payment_method: formData.payment_method,
    payment_status: formData.payment_status,
    cod_amount: parseFloat(formData.cod_amount) || 0,
    collected_amount: parseFloat(formData.collected_amount) || 0,
    attempt_number: parseInt(formData.attempt_number, 10) || 1,
    reason_for_delay: formData.reason_for_delay,
    exception_notes: formData.exception_notes,
    proof_of_delivery: formData.proof_of_delivery,
    customer_signature: formData.customer_signature,
    delivery_photo: formData.delivery_photo,
    rating: parseFloat(formData.rating) || 0,
    feedback: formData.feedback,
    notes: formData.notes,
    internal_notes: formData.internal_notes,
    created_by: formData.created_by,
    assigned_to: formData.assigned_to,
    approved_by: formData.approved_by,
    completed_by: formData.completed_by,
    estimated_duration: formData.estimated_duration,
    actual_duration: formData.actual_duration,
    distance_km: parseFloat(formData.distance_km) || 0,
    route_id: formData.route_id,
    zone: formData.zone,
    territory: formData.territory,
    service_level: formData.service_level,
    temperature_controlled: formData.temperature_controlled,
    min_temperature: parseFloat(formData.min_temperature) || 0,
    max_temperature: parseFloat(formData.max_temperature) || 0,
    insurance_value: parseFloat(formData.insurance_value) || 0,
    insurance_provider: formData.insurance_provider,
    customs_required: formData.customs_required,
    customs_reference: formData.customs_reference,
    tax_amount: parseFloat(formData.tax_amount) || 0,
    discount_amount: parseFloat(formData.discount_amount) || 0,
    tip_amount: parseFloat(formData.tip_amount) || 0,
    return_required: formData.return_required,
    return_reason: formData.return_reason,
    reschedule_count: parseInt(formData.reschedule_count, 10) || 0,
    cancellation_reason: formData.cancellation_reason,
    warehouse_notes: formData.warehouse_notes,
    loading_notes: formData.loading_notes,
    unloading_notes: formData.unloading_notes,
    special_handling: formData.special_handling,
    hazmat: formData.hazmat,
    hazmat_class: formData.hazmat_class,
    perishable: formData.perishable,
    expiry_date: formData.expiry_date,
    batch_number: formData.batch_number,
    barcode: formData.barcode,
    qr_code: formData.qr_code,
    manifest_number: formData.manifest_number,
    pod_number: formData.pod_number,
    eta: formData.eta,
    eta_accuracy: formData.eta_accuracy,
    delay_minutes: parseFloat(formData.delay_minutes) || 0,
    sla_met: formData.sla_met,
    sla_breach_reason: formData.sla_breach_reason,
    escalation_level: parseInt(formData.escalation_level, 10) || 0,
    compliance_checked: formData.compliance_checked,
    audit_status: formData.audit_status,
    quality_score: parseFloat(formData.quality_score) || 0,
    performance_score: parseFloat(formData.performance_score) || 0,
    customer_satisfaction: parseFloat(formData.customer_satisfaction) || 0,
    nps_score: parseFloat(formData.nps_score) || 0,
    complaint_filed: formData.complaint_filed,
    complaint_reference: formData.complaint_reference,
    incident_reported: formData.incident_reported,
    incident_reference: formData.incident_reference,
    damage_reported: formData.damage_reported,
    damage_description: formData.damage_description,
    damage_value: parseFloat(formData.damage_value) || 0,
    insurance_claim: formData.insurance_claim,
    claim_reference: formData.claim_reference,
    refund_issued: formData.refund_issued,
    refund_amount: parseFloat(formData.refund_amount) || 0,
    credit_issued: formData.credit_issued,
    credit_amount: parseFloat(formData.credit_amount) || 0,
  };
}

/** Collapsible modal sections (field keys map to i18n label keys). */
export function getDeliveryFormSections(options) {
  const {
    statusOptions,
    priorityOptions,
    deliveryTypeOptions,
    zoneOptions,
    paymentMethodOptions,
    paymentStatusOptions,
    vehicleTypeOptions,
    yesNoOptions,
  } = options;

  return [
    {
      id: 'basicInfo',
      titleKey: 'section_basic_info',
      fields: [
        { key: 'delivery_reference', labelKey: 'col_reference', type: 'text' },
        { key: 'order_reference', labelKey: 'field_order_reference', type: 'text' },
        { key: 'tracking_number', labelKey: 'col_tracking', type: 'text' },
        { key: 'delivery_date', labelKey: 'col_delivery_date', type: 'date' },
        { key: 'scheduled_date', labelKey: 'field_scheduled_date', type: 'date' },
        { key: 'status', labelKey: 'col_status', type: 'select', options: statusOptions },
        { key: 'priority', labelKey: 'field_priority', type: 'select', options: priorityOptions },
        { key: 'delivery_type', labelKey: 'field_delivery_type', type: 'select', options: deliveryTypeOptions },
      ],
    },
    {
      id: 'customer',
      titleKey: 'section_customer',
      fields: [
        { key: 'customer_name', labelKey: 'col_customer', type: 'client', required: true },
        { key: 'customer_phone', labelKey: 'field_customer_phone', type: 'text' },
        { key: 'customer_email', labelKey: 'field_customer_email', type: 'email' },
      ],
    },
    {
      id: 'delivery',
      titleKey: 'section_delivery',
      fields: [
        { key: 'delivery_address', labelKey: 'col_address', type: 'text', fullWidth: true },
        { key: 'delivery_city', labelKey: 'col_city', type: 'text' },
        { key: 'delivery_region', labelKey: 'field_region', type: 'text' },
        { key: 'delivery_postal_code', labelKey: 'field_postal_code', type: 'text' },
        { key: 'zone', labelKey: 'field_zone', type: 'select', options: zoneOptions },
        { key: 'delivery_instructions', labelKey: 'field_instructions', type: 'textarea', fullWidth: true },
      ],
    },
    {
      id: 'tracking',
      titleKey: 'section_tracking',
      fields: [
        { key: 'driver_name', labelKey: 'col_driver', type: 'text' },
        { key: 'driver_phone', labelKey: 'field_driver_phone', type: 'text' },
        { key: 'vehicle_number', labelKey: 'field_vehicle_number', type: 'text' },
        { key: 'vehicle_type', labelKey: 'field_vehicle_type', type: 'select', options: vehicleTypeOptions },
        { key: 'distance_km', labelKey: 'field_distance_km', type: 'number' },
      ],
    },
    {
      id: 'costs',
      titleKey: 'section_costs',
      fields: [
        { key: 'delivery_cost', labelKey: 'field_delivery_cost', type: 'number' },
        { key: 'total_cost', labelKey: 'field_total_cost', type: 'number' },
        { key: 'payment_method', labelKey: 'field_payment_method', type: 'select', options: paymentMethodOptions },
        { key: 'payment_status', labelKey: 'field_payment_status', type: 'select', options: paymentStatusOptions },
        { key: 'cod_amount', labelKey: 'field_cod_amount', type: 'number' },
        { key: 'signature_required', labelKey: 'field_signature_required', type: 'select', options: yesNoOptions },
      ],
    },
    {
      id: 'notes',
      titleKey: 'section_notes',
      fields: [
        { key: 'notes', labelKey: 'label_notes', type: 'textarea', fullWidth: true },
        { key: 'internal_notes', labelKey: 'field_internal_notes', type: 'textarea', fullWidth: true },
      ],
    },
  ];
}

/** View modal rows (table columns + extra detail fields). */
export const DELIVERY_VIEW_COLUMNS = [
  { key: 'delivery_reference', labelKey: 'col_reference' },
  { key: 'tracking_number', labelKey: 'col_tracking' },
  { key: 'customer_name', labelKey: 'col_customer' },
  { key: 'delivery_date', labelKey: 'col_delivery_date' },
  { key: 'status', labelKey: 'col_status' },
  { key: 'delivery_city', labelKey: 'col_city' },
  { key: 'driver_name', labelKey: 'col_driver' },
  { key: 'delivery_address', labelKey: 'col_address' },
  { key: 'priority', labelKey: 'field_priority' },
  { key: 'delivery_type', labelKey: 'field_delivery_type' },
  { key: 'total_cost', labelKey: 'field_total_cost' },
  { key: 'notes', labelKey: 'label_notes' },
];
